import { useQuery } from "@tanstack/react-query"

import MetricDisplay from "@/features/dashboards/components/MetricDisplay.tsx"

import type { DailyDisplayData } from "../types/dailyDisplayTypes.ts"

export default function DailyDisplay({ fetcher }: { fetcher: () => Promise<DailyDisplayData> }) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["dailyDisplay", { location: 3 }],
    queryFn: fetcher,
    refetchInterval: 60000,
  })

  return (
    <div className="rounded-md shadow-sm p-4 border col-span-4 md:col-span-1 h-[325px]">
      <h2 className="text-lg font-semibold">Daily Totals</h2>
      <div className="flex flex-col gap-3 mt-3">
        <MetricDisplay
          label="Total Manure Trucked"
          value={data ? data.manure : 0}
          loading={isPending}
          error={isError}
          unit="Gallons"
        />
        <MetricDisplay
          label="Total UF Trucked"
          value={data ? data.uf : 0}
          loading={isPending}
          error={isError}
          unit="Gallons"
        />
        <MetricDisplay
          label="Total Loads"
          loading={isPending}
          error={isError}
          value={data ? data.loads : 0}
          unit="#"
        />
      </div>
    </div>
  )
}
